import { Subscription } from 'rxjs/Subscription';
import { Component, OnInit, OnDestroy } from '@angular/core';
import store from './../../../store/store.module';
import {
  REMOVE_DATA_DELIVERY,
  ADD_DATA_DELIVERY,
  CREATE_DELIVERYS_REQUESTED,
  TOGGLE_COLLAPSE_DATA_DELIVERY, SEARCH_AND_ADD_DATA_DELIVERY
} from './create.actions';
import * as _ from 'lodash';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {FETCH_CONSTANTS_REQUESTED} from "../../../store/constant/list/list.actions";
import {FILTER_PRODUCT_REQUESTED} from "../../product/list/list.actions";
import {Subject} from "rxjs/Subject";
import {DELIVERY_COMP} from "../delivery.const";
import {debounceTime} from "rxjs/operators";
import {FILTER_COLLECTIONS_REQUESTED, SEARCH_COLLECTIONS_REQUESTED} from "../../collection/list/list.actions";
const READY_TO_BE_SHIPPED = 'READY_TO_BE_SHIPPED';
const SHIPPING = 'SHIPPING';
const SHIPPED = 'SHIPPED';
import { Countries } from '../../../common/data/countries';
import {AppInjector} from "../../../app-injector";
import {CREATE_CUSTOMER_ADDRESS_REQUESTED, UPDATE_CUSTOMER_ADDRESS_REQUESTED} from "../../customer/edit/edit.actions";
@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit, OnDestroy {
  public navigationSubscription: Subscription;
  public store = store;
  public defaultData = {
    object_type: '',
    delivery_type: '',
    object_id: ''
  };
  public data = {...this.defaultData};
  public COUNTRIES = Countries;
  public productSubject = new Subject<string>();
  public collectionSubject = new Subject<string>();
  constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, private router: Router) {
    this.activeRouter = activeRouter;
    this.router = router;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        store.dispatch({ type: FETCH_CONSTANTS_REQUESTED });
      }
    });
  }
  ngOnInit() {
    this.subscribeToCollection();
    this.subscribeToProduct();
  }
  subscribeToProduct() {
    this.productSubject.pipe(
      debounceTime(500),
    ).subscribe(term => {
      // ,[this.data.delivery_type.toLowerCase() + '_id']: null
      if (term) {
        store.dispatch({ type: FILTER_PRODUCT_REQUESTED, com: DELIVERY_COMP, data: { pagination: { page: 1, per_page: 10, search: term }, sort: null, filter: {
          notcontainsku: this.store.getState().Delivery.create.data.filter(s => s.object_type === 'product' ).map(s => s.details.sku).join(','),
          notpaymentsent: true
        }}});
      } else {
        store.dispatch({ type: FILTER_PRODUCT_REQUESTED, com: DELIVERY_COMP, data: { pagination: { page: 1, per_page: 10}, sort: null, filter: {
          notcontainsku: this.store.getState().Delivery.create.data.filter(s => s.object_type === 'product' ).map(s => s.details.sku).join(','),
          notpaymentsent: true
        } }});
      }
    }, () => {
    });
  }
  subscribeToCollection() {
    this.collectionSubject.pipe(
      debounceTime(500),
    ).subscribe(term => {
      if (term) {
        store.dispatch({ type: SEARCH_COLLECTIONS_REQUESTED, com: DELIVERY_COMP, data: { pagination: { page: 1, per_page: 10}, sort: null, filter: {
              notcontainname: this.store.getState().Delivery.create.data.filter(s => s.object_type === 'collection' ).map(s => s.details.name).join(','),
              [this.data.delivery_type.toLowerCase() + '_id']: null
            }, search: term }});
      } else {
        store.dispatch({ type: SEARCH_COLLECTIONS_REQUESTED, com: DELIVERY_COMP, data: { pagination: { page: 1, per_page: 10}, sort: null, filter: {
              notcontainname: this.store.getState().Delivery.create.data.filter(s => s.object_type === 'collection' ).map(s => s.details.name).join(','),
              [this.data.delivery_type.toLowerCase() + '_id']: null
            }, search: null }});
      }
    }, () => {
    });
  }
  changeSearch(type) {
    this.data.object_type = type;
  }
  removeData(key) {
    store.dispatch({ type: REMOVE_DATA_DELIVERY, com: DELIVERY_COMP, key});
  }
  addData(id, type, delivery_type) {
    if (id && type && delivery_type) {
      let data = null;
      if (type === 'product') {
        data = store.getState().Product.list.items.find(s => s.id === id);
      } else if (type === 'collection') {
        data = store.getState().Collection.list.items.find(s => s.id === id);
      }
      if (store.getState().Delivery.create.data.length > 0) {
        store.dispatch({ type: ADD_DATA_DELIVERY, com: DELIVERY_COMP, data: {
            'object_type': type,
            'object_id': id,
            'delivery_type': delivery_type,
            'content': data
          }});
      } else {
        store.dispatch({ type: SEARCH_AND_ADD_DATA_DELIVERY, com: DELIVERY_COMP, data: {
            'object_type': type,
            'object_id': id,
            'delivery_type': delivery_type,
            'content': data
          }});
      }
      this.data['object_id'] = '';
      this.collectionSubject.next('');
      this.productSubject.next('');
    } else {
      this.notification.show('warning', 'Please check your delivery details', 5000);
    }
  }
  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }
  deliver(form, state) {
    if (form.valid) {
      if (state.data.length > 0) {
        let address = {
          ...state.address
        };
        address.phone = address.phone_arr;
        let sentData = {
          ...state.data[0],
          address: address,
          delivery_type: state.delivery_type,
          object_type: state.object_type
        };
        if (state.data.length > 1) {
          sentData['related_data'] = state.data.slice(1).map(s => s.object_id);
        }
        store.dispatch({ type: CREATE_DELIVERYS_REQUESTED, com: DELIVERY_COMP, data: [sentData]});
      }
    }
  }
  toggleDelivery(key) {
    store.dispatch({ type: TOGGLE_COLLAPSE_DATA_DELIVERY, com: DELIVERY_COMP, key});
  }
  saveAddressToCustomer(addr, customer) {
    if (!customer) {
      return;
    }
    if (!customer.id) {
      return;
    }
    addr.phone = addr.phone_arr;
    if (addr.id) {
      store.dispatch({
        type: UPDATE_CUSTOMER_ADDRESS_REQUESTED,
        data: _.assign({}, addr, {
          customer_id: customer.id
        }),
        com: DELIVERY_COMP
      });
    } else {
      store.dispatch({
        type: CREATE_CUSTOMER_ADDRESS_REQUESTED,
        data: _.assign({}, addr, {
          customer_id: customer.id
        }),
        com: DELIVERY_COMP
      });
    }
  }
}
